module.exports = __webpack_public_path__ + "img/4.f5c1563f.png";